import { Component, ElementRef, Input, NgZone, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Platform } from '@angular/cdk/platform';
import { AutoUnsubscribe, CombineSubscriptions } from '../../decorators/auto-unsubscribe.decorator';
import { Unsubscribable } from 'rxjs';

@Component({
    selector: 'metabase-stats',
    templateUrl: './metabase-stats.component.html',
    styleUrls: ['./metabase-stats.component.scss'],
    standalone: false
})
@AutoUnsubscribe()
export class MetabaseStatsComponent implements OnInit, OnChanges, OnDestroy {
  @CombineSubscriptions()
  subscriptions: Unsubscribable;

  @Input() reportUrl: string;
  @Input() organizationId?: number;
  currentFrameHeight = '100vh';
  url: string;
  showSpinner: boolean;
  @ViewChild('iframeId', { static: false }) iframeId: ElementRef<HTMLIFrameElement>;
  private reportOrigin?: string;
  private readonly windowMessageHandler = (event: MessageEvent) => this.handleWindowMessage(event);

  constructor(
    private ngZone: NgZone,
    private route: ActivatedRoute,
    public platform: Platform,
  ) {
    this.subscriptions = this.route.data.subscribe(res => {
      if (res?.organization) {
        const { results } = res.organization;
        this.setReportUrl(results[0].url);
      }
    });
  }

  ngOnInit() {
    window.addEventListener('message', this.windowMessageHandler);
  }

  ngOnChanges(_changes: SimpleChanges) {
    this.setupReport();
  }

  ngOnDestroy() {
    window.removeEventListener('message', this.windowMessageHandler);
  }

  setupReport() {
    this.showSpinner = true;
    this.currentFrameHeight = '100vh';
    if (this.reportUrl) {
      this.setReportUrl(this.reportUrl);
    }
  }

  loadSuccess() {
    this.showSpinner = false;
  }

  setReportUrl(reportUrl: string) {
    if (reportUrl) {
      this.reportOrigin = this.getOrigin(reportUrl);
      this.url = [reportUrl, '#bordered=false&titled=false'].join('');
    }
  }

  handleWindowMessage(event: MessageEvent) {
    const iframe = this.iframeId?.nativeElement;

    if (!iframe || event.source !== iframe.contentWindow) {
      return;
    }

    if (this.reportOrigin && event.origin !== this.reportOrigin) {
      return;
    }

    const metabaseEvent = event.data?.metabase;
    if (metabaseEvent?.type !== 'frame' || metabaseEvent?.frame?.mode !== 'fit') {
      return;
    }

    const height = Number(metabaseEvent.frame.height);
    if (!Number.isFinite(height) || height <= 0) {
      return;
    }

    this.ngZone.run(() => {
      this.currentFrameHeight = `${ height }px`;
    });
  }

  getOrigin(reportUrl: string): string | undefined {
    try {
      return new URL(reportUrl).origin;
    } catch {
      return undefined;
    }
  }

}
